import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import "./CellContent.scss";

import { StatefulToolTip } from "react-portal-tooltip";

class CellContent extends PureComponent {
  maxLength = 50;
  minLength = 10;

  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  toggleEllipsis = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    const { content, maxLevelNo } = this.props;
    const text = Array.isArray(content) ? content.join("\n") : content;
    let maxLengthForUse = this.maxLength;
    if (
      maxLevelNo?.axisOrdinates?.length &&
      maxLevelNo?.axisOrdinates?.length > 10
    ) {
      maxLengthForUse = maxLengthForUse - maxLevelNo.axisOrdinates.length;
      if (maxLengthForUse < this.minLength) maxLengthForUse = this.minLength;
    }
    const filteredLength = this.props.maxLength
      ? this.props.maxLength
      : maxLengthForUse;
    const textToDisplay = !this.state.open
      ? text.substring(0, filteredLength)
      : text;

    return (
      <React.Fragment>
        <p className="cell-content">
          <>
            <StatefulToolTip
              parent={textToDisplay}
              position="top"
              className="cm-cell-tooltip-span"
            >
              {text}
              <div style={{ textAlign: "center" }}>
                <Button
                  bsSize="xsmall"
                  onClick={() => {
                    navigator.clipboard.writeText(text);
                  }}
                >
                  Copy content
                </Button>
              </div>
            </StatefulToolTip>
            {text && text.length > filteredLength && !this.state.open ? (
              <span className="text-ellipsis dots">...</span>
            ) : null}
          </>
        </p>
      </React.Fragment>
    );
  }
}

export default CellContent;
